<template>
  <footer class="app-footer">
    <span>Husmind &copy; 2020</span>
    <span class="ml-auto">Powered by Tropical Media</span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue